import {
  CategoryValues,
  DailyPeriodValues,
  ForecastValues,
  RunTimeModelValues,
} from '../enums';
import { continents } from '@firebird-web/shared-constants';
import { DropdownOption } from '../../../../shared/interfaces/src/lib';
import {
  WeightedWidgetContinentOption,
  WeightedWidgetLocationType,
} from '../components/weighted-widget-location-type/weighted-widget-location-type.types';
import { NaChartSeriesModelRun } from '../../../../renewable/src/lib/modules/na-renewables/enums';
import {
  WidgetBlurbFilterConfig,
  WidgetBlurbPageSettings,
} from '../interfaces';

export const filterDropDownValues = [
  {
    labelKey: 'Min/Max Temp',
    value: 'MinMax',
    permission: ['Summary_Table', 'Min/Max_Forecast'],
  },
  {
    labelKey: 'Off-Peak Min/On-Peak Max Temp',
    value: 'Peak',
    permission: ['Summary_Table', 'OffPeak/OnPeak_Forecast'],
  },
  {
    labelKey: 'Average Temp',
    value: 'AverageTemp',
    permission: ['Summary_Table', 'Average_Forecast'],
  },
  {
    labelKey: 'HDD/CDD',
    value: 'DegreeDays',
    permission: ['Summary_Table', 'HDD/CDD_Forecast'],
  },
  {
    labelKey: 'Gas Day',
    value: 'GasDay',
    permission: ['Summary_Table', 'Gas_Day_Forecast'],
  },
  {
    labelKey: 'Min/Max Feels Like Temp',
    value: 'MinMaxFeelsLike',
    permission: ['Summary_Table', 'FeelsLike_Forecast'],
  },
  {
    labelKey: 'Max Dewpoint',
    value: 'MaxDewpoint',
    permission: ['Summary_Table', 'Dewpoint_Forecast'],
  },
  {
    labelKey: 'Precip Amount',
    value: 'precipAmount',
    permission: ['Summary_Table', 'Precip_Forecast'],
  },
  {
    labelKey: 'Probability of Precip',
    value: 'probabilityOfPrecip',
    permission: ['Summary_Table', 'Precip_Forecast'],
  },
];

export const AvailableFiltersForClimatology = ['MinMax', 'Peak', 'AverageTemp'];

export const AvailablePrimaryLensForClimatology = [
  'Forecast',
  'DepartureFromNorms',
];

export const primaryLensDropdown = [
  {
    labelKey: 'Forecast Values',
    shortLabelKey: 'Fcst Values',
    value: 'Forecast',
  },
  {
    labelKey: 'Departure From Norms',
    shortLabelKey: 'DFN',
    value: 'DepartureFromNorms',
  },
  {
    labelKey: 'Forecast Differences',
    shortLabelKey: 'Fcst Differences',
    value: 'ForecastDifference',
  },
];

export const primaryLensAvgTempDropdown = [
  {
    labelKey: 'Forecast Values',
    shortLabelKey: 'Fcst Values',
    value: 'Forecast',
  },
  {
    labelKey: 'Departure From Norms',
    shortLabelKey: 'DFN',
    value: 'DepartureFromNorms',
  },
  {
    labelKey: 'Forecast Differences',
    shortLabelKey: 'Fcst Differences',
    value: 'ForecastDifference',
  },
  {
    labelKey: 'Frisk Index',
    value: 'FriskIndex',
  },
];
export const primaryLensPrecipDropdown = [
  {
    labelKey: 'Forecast Values',
    shortLabelKey: 'Fcst Values',
    value: 'Forecast',
  },
  {
    labelKey: 'Forecast Differences',
    shortLabelKey: 'Fcst Differences',
    value: 'ForecastDifference',
  },
];

export const ForecastDifferenceValue = 'ForecastDifference';

export const CUSTOM_LIST = 'Custom List';

export const sumTableSizes = [
  { labelKey: 'Full Width', value: 'full' },
  { labelKey: 'Half Width', value: 'half' },
];
export const secondaryLensOptions = [
  { value: 'AvgYrThirty', labelKey: 'vs 30yr Avg', shortLabelKey: '30yr Avg' },
  { value: 'AvgYrTen', labelKey: 'vs 10yr Avg', shortLabelKey: '10yr Avg' },
  {
    value: 'LastYear',
    labelKey: 'vs Last Year Obs',
    shortLabelKey: 'Last Year Obs',
  },
];

export const CategoryDataSourceList: DropdownOption[] = [
  { value: CategoryValues.iso, labelKey: 'ISO Country' },
  { value: CategoryValues.degree, labelKey: 'Weighted Degree Days' },
];

export const DailyPeriodDataSourceList: DropdownOption[] = [
  { value: DailyPeriodValues.daily, labelKey: 'Daily' },
  { value: DailyPeriodValues.period, labelKey: 'Period' },
];

export const ForecastDataSourceList: DropdownOption[] = [
  { value: ForecastValues.ag2, labelKey: 'AG2' },
  { value: ForecastValues.model, labelKey: 'Model' },
];

export const RunTimeModelDataSourceList: DropdownOption[] = [
  { value: RunTimeModelValues.runTime, labelKey: 'Model Run Time' },
  { value: RunTimeModelValues.single, labelKey: 'Single Model' },
];

export const ParameterDataSourceList: DropdownOption[] = [
  { value: 'minMaxTemp', labelKey: 'Min/Max Temp' },
  { value: 'populationWeightedDd', labelKey: 'Population Weighted DD' },
];

export const EURParameterDataSourceList: DropdownOption[] = [
  { value: 'minMaxTemp', labelKey: 'Min/Max Temp' },
];

export const SUMMARY_TABLE_WIDGET_CUSTOM_LIST_CONTINENT = 'NA';

export const SUMMARY_TABLE_WIDGET_DEFAULT_CONTINENT = 'NA';

export const WEIGHTED_GRAPH_WIDGET_EUR_CONTINENT = 'EUR';

export const WEIGHTED_GRAPH_WIDGET_DEFAULT_ASIA_REGION = 'CHINA';

export const SUMMARY_TABLE_WIDGET_DEFAULT_REGION = 'All Regions';

export const WEIGHTED_GRAPH_WIDGET_DEFAULT_NA_ISO_REGION = 'MISO';

export const WEIGHTED_GRAPH_WIDGET_DEFAULT_NA_EIA_REGION = 'CONUS';

export const WEIGHTED_GRAPH_WIDGET_DEFAULT_EUR_REGION = 'AUSTRIA';

export const WEIGHTED_CONTINENTS = [
  continents.NORTH_AMERICA,
  continents.EUROPE,
  continents.ASIA,
  continents.MEXICO,
];

export const weightedNAPoolSet = [
  'WF-NA-POWER',
  'WF-NA-EAST',
  'WF-NA-WEST',
  'WF-NA',
];

export const weightedNAAllPoolSets = [
  'WF-NA-POWER',
  'WF-NA-EAST',
  'WF-NA-WEST',
  'WF-NA',
  'NA-GAS-GOLD',
  'WF-NA-GAS',
];

const ALL_WEIGHTED_WIDGET_LOCATION_TYPES: WeightedWidgetLocationType[] = [
  'iso',
  'degree',
];

export const ContinentList: WeightedWidgetContinentOption[] = [
  {
    text: 'North America',
    id: continents.NORTH_AMERICA,
    permission: ['WF-NA'],
    locationTypes: ALL_WEIGHTED_WIDGET_LOCATION_TYPES,
  },
  {
    text: 'Europe',
    id: continents.EUROPE,
    permission: ['WF-EUR'],
    locationTypes: ALL_WEIGHTED_WIDGET_LOCATION_TYPES,
  },
  {
    text: 'Asia',
    id: continents.ASIA,
    permission: ['WF-ASIA'],
    // TODO: re-enable 'degree' once Asia has 10 and 30 year normals.
    locationTypes: ['iso'],
  },
  {
    text: 'Mexico',
    id: continents.MEXICO,
    permission: ['WF-MEX'],
    // Weighted Degree Day location type isn't available for Mexico yet.
    locationTypes: ['iso'],
  },
];

export const ContinentListWDD = ContinentList.filter((continent) =>
  continent.locationTypes.includes('degree')
);

export const EurEiaWeightedWidgetLocations = [
  'BELGIUM',
  'CZECH_REPUBLIC',
  'DENMARK',
  'FRANCE',
  'GERMANY',
  'GREECE',
  'ITALY',
  'NORWAY',
  'SERBIA',
  'SPAIN',
  'SWITZERLAND',
  'TURKEY',
  'UNITED_KINGDOM',
];

export const RenewablesNaWidgetLegendModelToShow = [
  NaChartSeriesModelRun.AG2_LATEST,
  NaChartSeriesModelRun.AG2_MORNING,
  NaChartSeriesModelRun.AG2_PRIMARY_YESTERDAY,
  NaChartSeriesModelRun.ERCOT_STWPF_LATEST_MORNING,
  NaChartSeriesModelRun.ERCOT_STWPF_LATEST,
  NaChartSeriesModelRun.ERCOT_STWPF_MORNING,
  NaChartSeriesModelRun.LOCATION_PREVIOUS_MORNING,
  NaChartSeriesModelRun.LOCATION_MORNING,
  NaChartSeriesModelRun.LOCATION_LATEST,
];

export const RenewablesNaErcotLegendState = {
  [NaChartSeriesModelRun.AG2_LATEST]: true,
  [NaChartSeriesModelRun.AG2_MORNING]: true,
  [NaChartSeriesModelRun.AG2_PREVIOUS]: false,
  [NaChartSeriesModelRun.AG2_PRIMARY]: false,
  [NaChartSeriesModelRun.AG2_EVENING]: false,
  [NaChartSeriesModelRun.AG2_PRIMARY_YESTERDAY]: true,
  [NaChartSeriesModelRun.AG2_EVENING_YESTERDAY]: false,
  [NaChartSeriesModelRun.ERCOT_WGRPP_LATEST]: false,
  [NaChartSeriesModelRun.ERCOT_WGRPP_LATEST_MORNING]: false,
  [NaChartSeriesModelRun.ERCOT_WGRPP_PREVIOUS]: false,
  [NaChartSeriesModelRun.ERCOT_WGRPP_MORNING]: false,
  [NaChartSeriesModelRun.ERCOT_STWPF_LATEST_MORNING]: true,
  [NaChartSeriesModelRun.ERCOT_STWPF_LATEST]: true,
  [NaChartSeriesModelRun.ERCOT_STWPF_PREVIOUS]: false,
  [NaChartSeriesModelRun.ERCOT_STWPF_MORNING]: true,
  [NaChartSeriesModelRun.OBS]: true,
  [NaChartSeriesModelRun.FARM_CAPACITY]: false,
  [NaChartSeriesModelRun.CONFIDENCE_BANDS]: false,
};

export const RenewablesNaDefaultLegendState = {
  [NaChartSeriesModelRun.AG2_LATEST]: true,
  [NaChartSeriesModelRun.AG2_MORNING]: true,
  [NaChartSeriesModelRun.AG2_PREVIOUS]: false,
  [NaChartSeriesModelRun.AG2_PRIMARY]: false,
  [NaChartSeriesModelRun.AG2_EVENING]: false,
  [NaChartSeriesModelRun.AG2_PRIMARY_YESTERDAY]: true,
  [NaChartSeriesModelRun.AG2_EVENING_YESTERDAY]: false,
  [NaChartSeriesModelRun.LOCATION_MORNING]: true,
  [NaChartSeriesModelRun.LOCATION_LATEST]: true,
  [NaChartSeriesModelRun.LOCATION_PREVIOUS]: false,
  [NaChartSeriesModelRun.LOCATION_PREVIOUS_MORNING]: true,
  [NaChartSeriesModelRun.OBS]: true,
  [NaChartSeriesModelRun.FARM_CAPACITY]: false,
  [NaChartSeriesModelRun.CONFIDENCE_BANDS]: false,
};

export const DefaultWidgetBlurbPageSettings: WidgetBlurbPageSettings = {
  pageNumber: 1,
  pageSize: 10,
};

export const DefaultWidgetBlurbFilterConfig: WidgetBlurbFilterConfig = {
  experts: [],
  locations: [],
  keyWord: '',
};

export const WeightedISOPoolSets = [
  'WF-NA',
  'WF-NA-EAST',
  'WF-NA-WEST',
  'WF-EUR',
  'WF-ASIA',
  'WF-MEX',
  'WF-NA-POWER',
];
export const WeightedDDPoolSets = ['WF-EUR', 'WF-NA-GAS', 'NA-GAS-GOLD'];

export const yAxisZeroLineStyle = [
  {
    value: 0,
    color: '#afafaf',
    width: 1,
    zIndex: 5,
  },
];
